export const ARROZERA = {
    Codigo: 3,
    Nome: 'Arrozera',
    Modelo: 'GIR-1300',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Size: "auto 80%", 
            Url: "assets/IPB/Produtos/Arrozera/arrozera_1.png"
        }
    ],
    Detalhes: [
        `Distribuidor de uréia, adubo, calcário e sementes de arroz pré-germinada`,
        `Prato em INOX`,
        `Distribuição homogênea`,
        `Capacidade 500 litros`
    ],
    Modelos: [
        { Modelo: 'AR-500', Detalhes: '' },
    ]
}